<template>
  <div class="popup-full  _new-design  modal-we-find-you-work">
    <div class="popup-full__wrap">

      <button type="button"
              @click.prevent="onClose(false)"
              class="popup-full__close">
        <BaseSvg name="ico-close"/>
      </button>
      <div class="popup-full__scroll">
        <div class="popup-full__content">
          <div class="popup-full__main">
            <BasePreloader v-if="pending"/>

            <template v-if="receivedData">
              <div class="popup-full__media">
                <picture class="popup-full__img">
                  <source :srcset="receivedData.image_webp" type="image/webp"/>
                  <img :src="receivedData.image"
                       :alt="receivedData.heading">
                </picture>
              </div>

              <h3 style="font-size: 2.5rem"
                  class="popup-full__title">{{ receivedData.heading }}</h3>
              <div style="font-size: 1.8rem;font-weight: 500"
                   class="popup-full__text text">
                <p>{{
                    receivedData.description
                  }}</p>
              </div>


              <div class="popup-full__footer">
                <router-link-modified :to="{name: 'find-vacancy'}"
                                      style="font-weight: 400"
                                      @click.native="onClose(true)"
                                      class="popup-full__btn  base-btn  base-btn--green">
                  {{ receivedData.button_text }}
                </router-link-modified>
              </div>

              <!--              <div class="modal-we-find-you-work__soc-bot-wrap">-->
              <!--                <div class="modal-we-find-you-work__soc-bot-title">{{ receivedData.bot_name }}</div>-->
              <!--                <div class="modal-we-find-you-work__soc-bot-list">-->
              <!--                  <template v-for="messenger in messengers">-->
              <!--                    <a v-if="urls[messenger]"-->
              <!--                       :key="messenger"-->
              <!--                       :href="urls[messenger]"-->
              <!--                       target="_blank"-->
              <!--                       @click="onRespond(messenger)"-->
              <!--                       :class="'_' + messenger"-->
              <!--                       class="modal-we-find-you-work__soc-bot-item">-->
              <!--                      <BaseSvg :name="`ico-${messenger}`"/>-->
              <!--                    </a>-->
              <!--                    <div v-else-->
              <!--                         :key="messenger"-->
              <!--                         :class="'_' + messenger"-->
              <!--                         class="modal-we-find-you-work__soc-bot-item  _disabled">-->
              <!--                      <BaseSvg :name="`ico-${messenger}`"/>-->
              <!--                    </div>-->
              <!--                  </template>-->
              <!--                </div>-->
              <!--              </div>-->
            </template>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {http} from '@/axios'
  import { openCallBackModal } from '../helpers/modals/callBackModal'
  // import {mapGetters} from 'vuex'
  // import startChatBotPrimary from '@/actions/startChatBotPrimary'

  export default {
    name: 'ModalWeFindYouWork',
    props: {
      location: {
        type: String
      },
    },
    data() {
      return {
        pending: false,
        receivedData: null,
        urls: {},
        messengers: [
          'viber',
          'telegram',
          'messenger',
        ]
      }
    },
    computed: {
      // ...mapGetters('user', [
      //   'isLogged'
      // ])
    },
    methods: {
      load() {
        this.pending = true

        Promise.all([
          this.loadData(),
          this.loadUrls(),
        ])
          .finally(() => {
            this.pending = false
          })
      },
      loadData() {
        return http.get('/api/helper/popups')
          .then(({data}) => {
            this.receivedData = data.data.find(d => {
              return d.type === 'bot' && d.location === this.location
            })
          })
      },
      onClose(isRedirect) {
        if(isRedirect) {
          this.$vModal.offClose('we-find-you-work', this.afterClose)
        }

        this.$vModal.close('we-find-you-work')
      },
      afterClose() {
        openCallBackModal({ location: this.location });
      },
      loadUrls() {
        return http.get('/api/bot/primary-urls')
          .then(({data}) => {
            this.urls = data.data
          })
      },
      onRespond() {
        this.$vModal.offClose('we-find-you-work', this.afterClose)
        this.onClose()

        // if (!this.isLogged) return

        // this.pending = true
        //
        // startChatBotPrimary({messenger})
        //   .then(() => {
        //     this.onClose()
        //     this.$vModal.offClose('we-find-you-work', this.afterClose)
        //   })
        //   .finally(() => {
        //     this.pending = false
        //   })
      }
    },
    created() {
      this.loadUrls()
      this.load()
      this.$vModal.onClose('we-find-you-work', this.afterClose)
    },
    beforeDestroy() {
      this.$vModal.offClose('we-find-you-work', this.afterClose)
    }
  }
</script>

<style lang="less">

</style>
